/* eslint-disable import/order */
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { jsmWorkItemRoute } from '@jira/router-routes__servicedesk-jsm-work-item-routes/src/jsmWorkItemRoute.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { jsmWorkItemPageEntrypoint } from './ui/jsmWorkItemPageEntrypoint.tsx';

export const jsmWorkItemRouteEntry: Route = createEntry(jsmWorkItemRoute, () => ({
	group: 'servicedesk',

	layout: globalLayout,

	navigation: {
		menuId: MenuIdProjects,
	},

	resources: [...getNavigationResources()],

	entryPoint: () =>
		fg('jsm_aniv_routing_phase_1') ? jsmWorkItemPageEntrypoint : notFoundPageEntrypoint,

	bifrost: {
		bifrostGroup: 'shell-only',
		redirects: [
			{
				key: 'jsm-work-item-route-redirect',
				timeoutMs: 10,
				handler: async ({ match, url }) => {
					const issueKey = match.params.issueKey;

					// eslint-disable-next-line jira/ff/no-preconditioning
					if (issueKey && !(fg('jsm_aniv_routing_phase_1') && fg('jsm_aniv_route_redirection'))) {
						return `/browse/${issueKey}${url.search}`;
					}
				},
			},
		],
	},
}));
